import CardBottom from '../components/CampaignDetails/CardBottom';
import ContentPostCard from './CampaignDetails/ContentPostCard';
import ContentReelCard from './CampaignDetails/ContentReelCard';

const contentComponentMap = {
  post: ContentPostCard,
  story: ContentPostCard,
  reel: ContentReelCard,
  ytVideo: ContentReelCard,
  ttVideo: ContentReelCard,
  ttStory: ContentReelCard,
  ytShort: ContentReelCard,
  ytStory: ContentReelCard,
};

export default function ContentCard({ post, hideCardBottom, style = {}, hideCardTop }) {
  const ContentComponent = contentComponentMap[post.type];
  return ContentComponent ? (
    <div className={`sl-content-card ${hideCardTop ? 'hide-top' : ''} ${post.type}`} style={style}>
      <ContentComponent key={post._id} content={post} hideCardTop={hideCardTop} />
      {!hideCardBottom && <CardBottom content={post} />}
    </div>
  ) : (
    <></>
  );
}
